import { usePlausible } from "next-plausible";
import { useFetchImpactShopStore } from "../../store/impact-shop";
import { useStore } from "../../store";

export type AnalyticsEventName =
  | "impactShopProductClick"
  | "impactShopAddToBasket"
  | "impactShopRemoveFromBasket"
  | "impactShopBasketGoToCheckout"
  | "impactShopBasketPayNow"
  | "impactShopBasketQuantityIncrease"
  | "impactShopBasketQuantityDecrease"
  | "impactShopBasketQuantityEdit"
  | "impactShopPurchase"
  | "impactShopBasketSignInClick"
  | "impactShopBasketRegisterClick";

export const useAnalytics = () => {
  const plausible = usePlausible();
  const useImpactShopStore = useFetchImpactShopStore();
  const impactShopStore = useImpactShopStore();
  const { user } = useStore();

  return {
    sendAnalyticsEvent: (
      eventName: AnalyticsEventName,
      props: Record<string, unknown> = {}
    ) => {
      const defaultProps = impactShopStore.utmParams;
      const allProps = { ...defaultProps, ...props, isAuthenticated: !!user };
      plausible(eventName, { props: allProps });
    },
  };
};
